import { Navbar } from "@/components/Navbar";
import { Hero } from "@/components/Hero";
import { NarratorRobot } from "@/components/NarratorRobot";
import { TogetherStrong, StoryInvite } from "@/components/HomeSections";
import { Footer } from "@/components/Footer";
import { ScrollProgress } from "@/components/ScrollProgress";
import { CookieBanner } from "@/components/CookieBanner";
import { useSeo } from "@/hooks/useSeo";

export default function Home() {
  useSeo();

  return (
    <div className="min-h-screen bg-[#FAF9F6]">
      <ScrollProgress />
      <Navbar />
      <main>
        <Hero />
        <NarratorRobot />
        <TogetherStrong />
        <StoryInvite />
      </main>
      <Footer />
      <CookieBanner />
    </div>
  );
}
